export enum FilterActionTypes {
  None = 0,
  Add = 1,
  Update = 2,
  Remove = 3,
}
